module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-driver-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-6"
  }, [_c('driver', {
    attrs: {
      "type": 'driver-card',
      "item": _vm.item
    }
  })], 1), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "field-status"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))])])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-6"
  }, [_c('driver', {
    attrs: {
      "type": 'highlightedNotes',
      "item": _vm.item
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('router-tab-headers', {
    attrs: {
      "id": "driver-details",
      "tabs": _vm.tabs
    }
  }, [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d51e5ad!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Driver.vue
// module id = 2329
// module chunks = 1